import { Icon } from "@iconify/react";
import { AutoComplete, Button, Card, Checkbox, Col, Descriptions, Divider, Flex, Form, Grid, Input, InputNumber, message, Modal, Popconfirm, Radio, Row, Segmented, Select, Space, Steps, Typography, Upload } from "antd";
import { useEffect, useRef, useState } from "react";
import pallete from "../../utils/pallete";
import { Link, useNavigate, useParams } from "react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { surveyService } from "../../services/survey.service";
import RenderIf from "../../components/RenderIf";
import { MAX_FILE_SIZE } from "../../utils/const";
import { API_BASE_URL } from "../../config/api.config";
import { getFileExtension } from "../../utils/getFileExtension";
import { masterDataTypeService } from "../../services/master-data-type.service";
import { skemaPembayaran, sumberAir } from "../../utils/options.data";
import { canUploadImage } from "../../utils/imageValidator";
import UploadFileRenderer from "../../components/FileUploadRenderer";
import MapComponent from "../../components/Maps";
import useDebounce from "../../hooks/useDebounce";
import { mapsService } from "../../services/maps.service";

const validateForm = [
  ['nama', 'telepon', 'no_hp', 'nama_penanggung_jawab', 'no_nik', 'no_kk', 'no_pbb', 'no_sertifikat', 'email', 'kota', 'kecamatan', 'kelurahan', 'jalan', 'no_rumah', 'kode_pos', 'rt', 'rw', 'status_penghuni', 'jumlah_penghuni', 'lingkungan_tertata', 'jenis_pemukiman_id', 'luas_bangunan', 'kode_tarif_id'],
  ['lokasi_bangunan', 'latitude', 'longitude'],
  ['novak_blok', 'nomen_terdekat', 'sumber_lain', 'jaringan_pipa', 'jarak_bangunan_dengan_pipa', 'ukuran_pipa_id', 'diameter_pipa_id', 'jenis_jalan_id', 'perlu_crossing_jalan', 'lebar_jalan', 'perlu_crossing_air', 'panjang_casing_pipa', 'perlu_crossing_air', 'sanitasi', 'saluran_pembuangan', 'halaman', 'golongan_konsumen_id', 'nomen_lama', 'tekanan_air', 'peruntukan_bangunan', 'perlu_bor_tembok', 'lebar_jalan', 'pa_pc', 'blok_ez', 'cc'],
  ['kamar_tidur', 'kamar_mandi', 'ruang_tamu', 'ruang_makan', 'ruang_keluarga', 'dapur', 'teras', 'garasi', 'gudang', 'jumlah_lantai'],
  ['skema_pembayaran', 'keterangan_lain', 'program_sambungan_baru_id', 'program_kategori', 'nama_program_kategori', 'object_id_bnba', 'field_survey_id_maps_bnba']
]

// eslint-disable-next-line react/prop-types
const CardList = ({ name, title, subtitle, disabled, handleChange }) => {
  return (
    <Card
      styles={{
        body: {
          padding: '14px 21px',
          backgroundColor: disabled ? pallete.grey[200] : '#fff'
        }
      }}
    >
      <Space size={'middle'} >
        <Form.Item name={name} valuePropName="checked" noStyle >
          <Checkbox onChange={handleChange} disabled={disabled} />
        </Form.Item>
        <div>
          <Typography.Title level={5} style={{ marginBottom: 4, fontWeight: 500 }} >
            {title}
          </Typography.Title>
          <Typography.Text type="secondary" >
            {subtitle}
          </Typography.Text>
        </div>
      </Space>
    </Card>
  )
}

const addressNumberFormatter = {
  formatter: (value) => {
    const numericValue = value.replace(/\D/g, '');

    if (numericValue) {
      return numericValue.padStart(3, '0');
    }
    return '';
  },
  parser: (value) => {
    return value.replace(/\D/g, '');
  }
}

export default function DocumentAnalysisOfficerDetail() {

  const navigate = useNavigate()

  const { id } = useParams()

  const queryClient = useQueryClient();

  const autoCompleteRef = useRef(null)

  const breakpoint = Grid.useBreakpoint()

  const [stepPosition, setStepPosition] = useState(0);
  const [cancle, setCancle] = useState({
    cancellable: false,
    status: false
  })
  const [customerImage, setCustomerImage] = useState([])
  const [serviceLetter, setServiceLetter] = useState([])
  const [additionalLetter, setAdditionalLetter] = useState([])
  const [previewImage, setPrevieImage] = useState('')
  const [currSegment, setCurrSegment] = useState('Task Checklist')
  const [openChangeModal, setOpenChangedDocument] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  const [changedDocumentType, setChangedDocumentType] = useState('')
  const [changedDocument, setChangedDocument] = useState([])

  const [selectedAddress, setSelectedAddress] = useState('')
  const [searchAddress, setSearchAddress] = useState('')
  const [position, setPosition] = useState([-6.1995, 106.8118])

  const addressDebounce = useDebounce(searchAddress, 300)

  const [form] = Form.useForm()
  const [rejectForm] = Form.useForm()
  const [surveyForm] = Form.useForm()
  const [notesForm] = Form.useForm()


  const { data } = useQuery({
    queryKey: ['detailSurveyData', id],
    queryFn: () => surveyService.getOfficerCheckingDataById(id),
    enabled: !!id
  })

  const { data: surveyData } = useQuery({
    queryKey: ['detailSurveyDataForm', id],
    queryFn: () => surveyService.getById(id),
    enabled: !!id
  })

  const { data: jenisPemukimanMaster } = useQuery({
    queryKey: ['jenisPemukiman'],
    queryFn: () => masterDataTypeService.getByName('Jenis Pemukiman'),
  })

  const { data: diameterPipaMaster } = useQuery({
    queryKey: ['diameterPipa'],
    queryFn: () => masterDataTypeService.getByName('Diameter Pipa Dinas'),
  })

  const { data: kodeTarifMaster } = useQuery({
    queryKey: ['kodeTarif'],
    queryFn: () => masterDataTypeService.getByName('Kode Tarif'),
  })

  const { data: ukuranPipaMaster } = useQuery({
    queryKey: ['ukuranPipa'],
    queryFn: () => masterDataTypeService.getByName('Ukuran Pipa'),
  })

  const { data: jenisJalanMaster } = useQuery({
    queryKey: ['jenisJalan'],
    queryFn: () => masterDataTypeService.getByName('Jenis Jalan'),
  })

  const { data: golonganKonsumenMaster } = useQuery({
    queryKey: ['golonganKonsumen'],
    queryFn: () => masterDataTypeService.getByName('Golongan Konsumen'),
  })

  const { data: programSambunganBaru } = useQuery({
    queryKey: ['programSambunganBaru'],
    queryFn: () => masterDataTypeService.getByName('Program Sambungan Baru'),
  })

  const { data: addressResponse } = useQuery({
    queryKey: ['searchAddress', addressDebounce],
    queryFn: () => mapsService.searchAddress(addressDebounce),
    enabled: !!addressDebounce
  })

  const reverseGeocodeMutation = useMutation({
    mutationFn: () => mapsService.reverseGeocode(position[0], position[1]),
    onSuccess: (data) => {
      setSelectedAddress(data.display_name)
      form.setFieldsValue({ lokasi_bangunan: data.display_name, latitude: Number(data.lat), longitude: Number(data.lon) });
    }
  })

  const watch = Form.useWatch((values) => values, form)

  const updateMutation = useMutation({
    mutationKey: ['updateMutation'],
    mutationFn: val => surveyService.updateInstallation(val),
    onSuccess: () => {
      message.success("Data berhasil ")
      queryClient.invalidateQueries('detailSurveyData')
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    }
  })

  const updateSurveyMutation = useMutation({
    mutationKey: ['updateSurvey'],
    mutationFn: val => surveyService.update(val),
    onSuccess: () => {
      message.success("Data berhasil disimpan")
    },
    onError: () => {
      message.error("Terjadi kesalahan")
    }
  })

  const storeNotesMutation = useMutation({
    mutationFn: body => surveyService.updateInstallation({ id, ...body }),
    onSuccess: () => {
      messageApi.success("Catatan berhasil disimpan")
    }
  })

  const uploadServiceLetterMutation = useMutation({
    mutationKey: ['uploadService'],
    mutationFn: val => surveyService.uploadServiceLetter(id, val),
  })

  const uploadFileMutation = useMutation({
    mutationKey: ['uploadAdditional'],
    mutationFn: val => surveyService.uploadAdditionalLetter(id, val),
    onSuccess: () => {
      queryClient.invalidateQueries('detailSurveyData')
    }
  })

  const deleteFileMutation = useMutation({
    mutationKey: ['deleteFile'],
    mutationFn: val => surveyService.deleteFile(id, val),
    onSuccess: () => {
      message.success("Data berhasil dihapus")
    },
    onError: (res) => {
      console.log(res)
      message.error("Terjadi kesalahan")
    }
  })

  const changedDocumentMutation = useMutation({
    mutationFn: val => surveyService.changeDocument(id, val),
    onSuccess: () => {
      setOpenChangedDocument(false)
      message.success("Document Berhasil diubah")
      queryClient.invalidateQueries('detailSurvey')
    },
    onError: (err) => {
      console.log(err)
    }
  })

  const rejectMutation = useMutation({
    mutationKey: ['rejectMutation'],
    mutationFn: (val) => surveyService.reject({ ...val, id }),
    onSuccess: () => {
      message.success("Data berhasil ditolak")
      return navigate('/document-analysis/process')
    }
  })

  useEffect(() => {
    if (id) {

      if (data?.data?.installation?.installedCompleted && data?.data?.installation?.plottingGis) {
        return navigate('/document-analysis/process')
      }

      form.setFieldsValue({
        inputSystem_ui: data?.data?.installation?.inputSystem,
        plottingGis_ui: data?.data?.installation?.plottingGis,
        billingForm_ui: data?.data?.installation?.billingForm,
        customerConfirmation_ui: data?.data?.installation?.customerConfirmation,
        assignFA_ui: data?.data?.installation?.assignFA,
        installedCompleted_ui: data?.data?.installation?.installedCompleted,
        nomen_ui: data?.data?.installation?.nomen,
      })

      notesForm.setFieldValue('finalNotes', data?.data?.installation?.finalNotes)

      if (data?.data?.serviceLetter) {
        setServiceLetter([
          {
            ...data?.data?.serviceLetter,
            name: data?.data?.serviceLetter.fileName,
            size: data?.data?.serviceLetter.fileSize,
          }
        ])
      }

      if (data?.data?.customerImage) {
        setCustomerImage(
          data?.data?.customerImage.map(e => ({
            ...e,
            name: e.fileName,
            size: e.fileSize,
            preview: `${API_BASE_URL}/files/${e.filePath}`
          }))
        )
      }

      if (data?.data?.additionalLetter) {
        setAdditionalLetter(
          data?.data?.additionalLetter.map(e => ({
            ...e,
            name: e.fileName,
            size: e.fileSize,
          }))
        )
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, form, id])

  useEffect(() => {
    if (id && surveyData?.data) {
      surveyForm.setFieldsValue(surveyData.data)
      setSelectedAddress(surveyData?.data?.lokasi_bangunan)
      surveyForm.setFieldValue('latitude', Number(surveyData?.data?.koordinat?.latitude))
      surveyForm.setFieldValue('longitude', Number(surveyData?.data?.koordinat?.longitude))
      setPosition([Number(surveyData?.data?.koordinat?.latitude), Number(surveyData?.data?.koordinat?.longitude)])
    }
  }, [surveyForm, id, surveyData])

  useEffect(() => {
    setCancle({ ...cancle, cancellable: !watch?.inputSystem_ui })
  }, [watch])

  const handleSubmit = (val) => {
    const data = {
      inputSystem: val.inputSystem_ui,
      plottingGis: val.plottingGis_ui,
      billingForm: val.billingForm_ui,
      customerConfirmation: val.customerConfirmation_ui,
      assignFA: val.assignFA_ui,
      installedCompleted: val.installedCompleted_ui,
      activeCustomer: val.activeCustomer_ui,
      nomen: val.nomen_ui,
    }

    updateMutation.mutateAsync({ ...data, id })
      .then(() => {
        form.setFieldValue(val)
      })
  }

  const submitForm = (val) => {

    let submit = true

    if (val.installedCompleted_ui) {
      form.validateFields(['nomen_ui'])
        .catch(() => submit = false)
    }


    if (submit) {
      notesForm.validateFields()
        .then(() => {
          Modal.confirm({
            centered: true,
            title: "Pemberitahuan",
            content: val.installedCompleted_ui ? 'Yakin ingin menyelesaikan berkas ini ?' : "Yakin ingin melanjutkan proses ?",
            okText: 'Ya',
            cancelText: 'Batal',
            onOk: () => handleSubmit(val),
            okButtonProps: { loading: updateMutation.isPending, disabled: updateMutation.isPending },
            cancelButtonProps: { loading: updateMutation.isPending, disabled: updateMutation.isPending }
          })
        })
    }

  }

  const handleSubmitNotes = (val) => storeNotesMutation.mutate(val)

  const handleNext = () => {
    const data = surveyForm.getFieldsValue(validateForm[stepPosition])
    updateSurveyMutation.mutate({ ...data, id })
    if (stepPosition != 4) setStepPosition(stepPosition + 1)
  }

  const handleSelectAddress = () => {
    const address = autoCompleteRef.current.getPlaces()[0]
    console.log(address)
    const currLat = address.geometry.location.lat()
    const currLng = address.geometry.location.lng()
    console.log({ currLat, currLng })

    setSelectedAddress(address.formatted_address)
    surveyForm.setFieldValue('lokasi_bangunan', address.formatted_address)
    surveyForm.setFieldValue('latitude', currLat)
    surveyForm.setFieldValue('longitude', currLng)
  }

  const onChangeDocument = (type) => {
    setChangedDocumentType(type)
    setOpenChangedDocument(true)
  }

  const handleCloseChangedDocumentModal = () => {
    setChangedDocument([])
    setOpenChangedDocument(false)
  }

  const handleChangeDocument = () => changedDocumentMutation.mutate({ file: changedDocument[0], type: changedDocumentType })

  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const preprocessUpload = async (file) => {
    file.preview = await getBase64(file)
    if (!canUploadImage(file.name)) {
      message.error(`Format file tidak benar`);
      return Upload.LIST_IGNORE; // 
    }
    if (file.size > MAX_FILE_SIZE) {
      message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
      return Upload.LIST_IGNORE; // Mencegah upload
    }
  }

  const handleReject = val => {
    Modal.confirm({
      centered: true,
      title: "Pemberitahuan",
      content: "Yakin ingin cancel berkas ?",
      onOk: () => rejectMutation.mutate(val)
    })
  }

  return (
    <>
      {contextHolder}
      <Card
        title="Detail Analisis Berkas"
        extra={
          <Segmented
            options={['Task Checklist', 'Data Survey']}
            onChange={(e) => setCurrSegment(e)}
            value={currSegment}
          />
        }
        actions={[
          <>
            <Flex key={'1'} justify="end" gap={16} style={{ paddingRight: 24 }} >
              <RenderIf when={cancle.cancellable} >
                <Button onClick={() => setCancle({ ...cancle, status: true })} variant="filled" color="danger" >
                  Tolak
                </Button>
              </RenderIf>
              <RenderIf key={'1'} when={currSegment != 'Task Checklist'} >
                <Button
                  onClick={() => setStepPosition(stepPosition - 1)}
                  variant="outlined"
                  color="primary"
                  disabled={stepPosition == 0}
                >
                  Kembali
                </Button>
                <Button
                  onClick={handleNext}
                  variant="solid"
                  color="primary"
                >
                  Selanjutnya
                </Button>
              </RenderIf>
              <RenderIf when={currSegment == 'Task Checklist'} >
                <Button
                  disabled={updateMutation.isPending}
                  loading={updateMutation.isPending}
                  block={!breakpoint.md}
                  onClick={() => navigate('/document-analysis/process')}
                  variant="outlined" color="primary"
                >
                  Batal
                </Button>
                <Button
                  variant="solid"
                  color="primary"
                  onClick={() => form.submit()}
                  block={!breakpoint.md}
                  loading={updateMutation.isPending}
                  disabled={updateMutation.isPending}
                >
                  Simpan
                </Button>
              </RenderIf>
            </Flex>
            <RenderIf when={cancle.status} >
              <div style={{ padding: '6px 21px' }} >
                <Form
                  form={rejectForm}
                  layout="vertical"
                  onFinish={handleReject}
                >
                  <Form.Item style={{ textAlign: 'left' }} label="Alasan Tolak" name={'reason'} rules={[{ required: true }]} >
                    <Input.TextArea>
                    </Input.TextArea>
                  </Form.Item>
                </Form>
                <Flex gap={18} justify="end" >
                  <Button onClick={() => setCancle({ ...cancle, status: false })} variant="outlined" color="danger" >
                    Batal
                  </Button>
                  <Button onClick={rejectForm.submit} variant="solid" color="primary" >
                    Simpan
                  </Button>
                </Flex>
              </div>
            </RenderIf>
          </>
        ]}
      >
        <RenderIf when={currSegment == 'Task Checklist'} >
          <Descriptions
            bordered
            layout="vertical"
            size="small"
            styles={{ label: { width: 120 } }}
            style={{ marginBottom: 20 }}
            items={[
              {
                label: 'Catatan dari Marketing',
                children: data?.data.acceptanceNotes
              }
            ]}
          />
          <div style={{ marginBottom: 20 }} >
            <Upload
              style={{ width: '100%', display: 'block' }}
              rootClassName="survey-upload"
              // disabled={customerImage.length != 0}
              disabled={true}
              // beforeUpload={(file) => {
              //   if (file.size > MAX_FILE_SIZE) {
              //     message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
              //     return Upload.LIST_IGNORE; // Mencegah upload
              //   }
              //   uploadCustomerImageMutation.mutateAsync({ image: file })
              //   .then(res => {
              //     setCustomerImage([
              //       {
              //         ...res.data,
              //         name: res?.data?.fileName,
              //         size: res?.data?.fileSize,
              //         preview: `${API_BASE_URL}/files/`+res?.data.filePath
              //       }
              //     ])
              //     return false
              //   })
              //   .catch(err => console.log(err))
              // }}
              fileList={customerImage}
              onRemove={(file) => {
                deleteFileMutation.mutateAsync(file.id)
                  .then(() => setCustomerImage([]))
                  .catch(err => console.log(err))
              }}
              itemRender={(_, file, filelist, action) => (
                <UploadFileRenderer
                  file={file}
                  action={action}
                  activeDelete={false}
                  deleteLoading={deleteFileMutation.isPending}
                  onPreview={() => setPrevieImage(file.preview)}
                />
              )}
            >
              <Flex justify="space-between" >
                <div style={{ flex: 1 }} >
                  <Typography.Text style={{ display: 'block' }} >
                    Foto Kustomer
                  </Typography.Text>
                  <Typography.Text type="secondary" >
                    File jpeg, png, jpg, Max. file size: 2 MB
                  </Typography.Text>
                </div>
                <Button
                  icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                  disabled={serviceLetter.length != 0}
                >
                  Upload
                </Button>
              </Flex>
            </Upload>
          </div>
          <div style={{ marginBottom: 20 }} >
            <Upload
              style={{ width: '100%', display: 'block' }}
              rootClassName="survey-upload"
              disabled={serviceLetter.length == 1}
              fileList={serviceLetter}
              onRemove={(file) => {
                deleteFileMutation.mutateAsync(file.id)
                  .then(() => setServiceLetter([]))
                  .catch(err => console.log(err))
              }}
              beforeUpload={(file) => {
                if (file.size > MAX_FILE_SIZE) {
                  message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                  return Upload.LIST_IGNORE; // Mencegah upload
                }
                uploadServiceLetterMutation.mutateAsync({ serviceLetter: file })
                  .then(res => {
                    setServiceLetter([
                      {
                        ...res.data,
                        name: res?.data?.fileName,
                        size: res?.data?.fileSize,
                        preview: res?.data.filePath
                      }
                    ])
                  })
                  .catch(err => {
                    console.error("Error uploading file:", err);
                  });

                return false;
              }}
              itemRender={(_, file, fileList, action) => (
                <Card
                  style={{ marginTop: 20 }}
                  styles={{
                    body: {
                      padding: '10px 14px'
                    }
                  }}
                >
                  <Flex align="center" gap={10} >
                    <Space direction="vertical" size={2} style={{ marginRight: 'auto' }} >
                      <Typography.Text style={{ fontWeight: 500, marginBottom: 0 }} >
                        {file.name}
                      </Typography.Text>
                    </Space>
                    <Button
                      icon={<Icon icon='solar:eye-bold-duotone' />}
                      color="primary"
                      variant="outlined"
                      size="small"
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/${file.filePath}`)}
                    />
                    <Popconfirm
                      placement="left"
                      title="Pemberitahuan"
                      description="Yakin ingin hapus file ?"
                      okButtonProps={{
                        danger: true,
                        loading: deleteFileMutation.isPending
                      }}
                      okText="Hapus"
                      onConfirm={action.remove}
                    >
                      <Button
                        icon={<Icon icon='solar:trash-bin-minimalistic-bold-duotone' />}
                        danger
                        size="small"
                      />
                    </Popconfirm>
                  </Flex>
                </Card>
              )}
            >
              <Flex justify="space-between" >
                <div style={{ flex: 1 }} >
                  <Typography.Text style={{ display: 'block' }} >
                    Surat Pelayanan Sementara
                  </Typography.Text>
                  <Typography.Text type="secondary" >
                    File jpeg, png, jpg, pdf, Max. file size: 2 MB
                  </Typography.Text>
                </div>
                <Button
                  icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                  disabled={serviceLetter.length == 1}
                >
                  Upload
                </Button>
              </Flex>
            </Upload>
          </div>
          <div style={{ marginBottom: 20 }} >
            <Upload
              style={{ width: '100%', display: 'block' }}
              rootClassName="survey-upload"
              multiple
              disabled={additionalLetter.length == 5}
              beforeUpload={(file) => {
                if (file.size > MAX_FILE_SIZE) {
                  message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
                  return Upload.LIST_IGNORE; // Mencegah upload
                }
                uploadFileMutation.mutateAsync({ additionalLetter: file })
                  .then(res => {
                    const uploadedFiles = Array.isArray(res.data) ? res.data : [res.data];

                    const newFiles = uploadedFiles.map(e => ({
                      ...e,
                      name: e.fileName,
                      size: e.fileSize,
                    }));

                    setAdditionalLetter(prevAdditionalLetter => [
                      ...prevAdditionalLetter,
                      ...newFiles,
                    ]);
                  })
                  .catch(err => {
                    console.error("Error uploading file:", err);
                  });

                return false;
              }}
              fileList={additionalLetter}
              onRemove={(file) => {
                deleteFileMutation.mutateAsync(file.id).then(() => {
                  const index = additionalLetter.indexOf(file);
                  const newFileList = additionalLetter.slice();
                  newFileList.splice(index, 1);
                  setAdditionalLetter(newFileList);
                })
              }}
              itemRender={(_, file, filelist, action) => (
                <Card
                  style={{ marginTop: 20 }}
                  styles={{
                    body: {
                      padding: '10px 14px'
                    }
                  }}
                >
                  <Flex align="center" gap={10} >
                    <Space direction="vertical" size={2} style={{ marginRight: 'auto' }} >
                      <Typography.Text style={{ fontWeight: 500, marginBottom: 0 }} >
                        {file.name}
                      </Typography.Text>
                    </Space>
                    <Button
                      icon={<Icon icon='solar:eye-bold-duotone' />}
                      color="primary"
                      variant="outlined"
                      size="small"
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/${file.filePath}`)}

                    />
                    <Popconfirm
                      placement="left"
                      title="Pemberitahuan"
                      description="Yakin ingin hapus file ?"
                      okButtonProps={{
                        danger: true,
                        loading: deleteFileMutation.isPending
                      }}
                      okText="Hapus"
                      onConfirm={action.remove}
                    >
                      <Button
                        icon={<Icon icon='solar:trash-bin-minimalistic-bold-duotone' />}
                        danger
                        size="small"
                      />
                    </Popconfirm>
                  </Flex>
                </Card>
              )}
            >
              <Flex justify="space-between" >
                <div style={{ flex: 1 }} >
                  <Typography.Text style={{ display: 'block' }} >
                    Dokumen Pendukung
                  </Typography.Text>
                  <Typography.Text type="secondary" >
                    File jpeg, png, jpg, pdf, Max. file size: 2 MB
                  </Typography.Text>
                </div>
                <Button
                  icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                  disabled={additionalLetter.length == 5}
                >
                  Upload
                </Button>
              </Flex>
            </Upload>
          </div>
          <Form
            form={form}
            layout="vertical"
            onFinish={submitForm}
          >

            <Space direction="vertical" size={"middle"} style={{ width: '100%' }} >
              <CardList
                name={'inputSystem_ui'}
                title={'Input Sistem'}
                subtitle={'Validasi'}
                disabled={watch?.assignFA || data?.data?.installation?.inputSystem}
              />
              <RenderIf when={watch?.assignFA || data?.data?.installation?.inputSystem} >
                <Row gutter={[20]} >
                  <Col span={12} >
                    <Form.Item label="FA Survey" >
                      <Input value={data?.data?.installation?.faSurvey} />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item label="Case ID" >
                      <Input value={data?.data?.installation?.caseID} />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item label="FA Pasang" >
                      <Input value={data?.data?.installation?.faInstall} />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item label="Nomen/Norek" >
                      <Input value={data?.data?.installation?.nomen} />
                    </Form.Item>
                  </Col>
                </Row>
              </RenderIf>
              <CardList
                name={'billingForm_ui'}
                title={'Cetak Form Billing'}
                subtitle={'Validasi'}
                disabled={watch?.assignFA || data?.data?.installation?.billingForm}
              />
              <CardList
                name={'customerConfirmation_ui'}
                title={'Konfirmasi Pelanggan'}
                subtitle={'Validasi'}
                disabled={watch?.assignFA || data?.data?.installation?.customerConfirmation}
              />
              <CardList
                name={'assignFA_ui'}
                title={'Assign FA'}
                subtitle={'Pemasangan'}
                disabled={!(data?.data?.installation?.inputSystem && data?.data?.installation?.billingForm && data?.data?.installation?.customerConfirmation) || data?.data?.installation?.assignFA}
              />
              <CardList
                name={'installedCompleted_ui'}
                title={'FA Install Completed'}
                subtitle={'Terpasang'}
                disabled={!(data?.data?.installation?.assignFA) || (data?.data?.installation?.installedCompleted)}
              />
              <RenderIf when={watch?.installedCompleted_ui} >
                <Form.Item
                  name={'nomen_ui'}
                  label="NOMEN/NOREK"
                  style={{ marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: /^\d{8,9}$/, // Hanya angka dengan panjang 8-9 digit
                      message: "Nomor harus terdiri dari 8 hingga 9 angka!",
                    },
                  ]}
                >
                  <Input
                    maxLength={9}
                    type="number"
                    disabled={!(data?.data?.installation?.assignFA) || (data?.data?.installation?.installedCompleted)}
                  />
                </Form.Item>
              </RenderIf>
            </Space>

            <Divider />

            <CardList
              name={'plottingGis_ui'}
              title={'Plotting GIS'}
              subtitle={''}
              disabled={watch?.assignFA || data?.data?.installation?.plottingGis}
            />

            <Divider />


          </Form>
          <Form
            layout="vertical"
            form={notesForm}
            onFinish={handleSubmitNotes}
          >
            <Form.Item rules={[{ required: true }]} style={{ textAlign: 'left' }} label="Catatan Final" name={'finalNotes'}  >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Form>

          <Flex justify="flex-end" >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => notesForm.submit()}
            >
              Simpan
            </Button>
          </Flex>
        </RenderIf>
        <RenderIf when={currSegment == 'Data Survey'} >
          <Flex gap={40} >
            <Form
              layout="vertical"
              style={{ flex: 1 }}
              form={surveyForm}
            >
              <Form.Item name={'id'} hidden >
                <Input />
              </Form.Item>
              <RenderIf when={stepPosition === 0} >
                <Row gutter={[20]} >
                  <Col sm={12} xs={24} >
                    <Form.Item
                      label="Nama"
                      name={'nama'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24} >
                    <Form.Item
                      label="Penanggung Jawab"
                      name={'nama_penanggung_jawab'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24} >
                    <Form.Item
                      name={'no_nik'}
                      label={'No KTP'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24} >
                    <Form.Item
                      name={'no_kk'}
                      label={'No KK'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24} >
                    <Form.Item
                      name={'no_pbb'}
                      label={'No PBB'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24} >
                    <Form.Item
                      name={'no_sertifikat'}
                      label={'No Sertifikat'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="No Telepon"
                      name={'telepon'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="No HP"
                      name={'no_hp'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Email"
                      name={'email'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[20]} >
                  <Col span={12} >
                    <Form.Item
                      label="Kota"
                      name={'kota'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Kecamatan"
                      name={'kecamatan'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[20]} >
                  <Col span={12} >
                    <Form.Item
                      label="Kelurahan"
                      name={'kelurahan'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Jalan"
                      name={'jalan'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[20]} >
                  <Col span={6} >
                    <Form.Item
                      label="No Rumah"
                      name={'no_rumah'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="Kode Pos"
                      name={'kode_pos'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="RT"
                      name={'rt'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        {...addressNumberFormatter}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="RW"
                      name={'rw'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        {...addressNumberFormatter}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[20]} >
                  <Col span={12} >
                    <Form.Item
                      label="Status Penghuni"
                      name={'status_penghuni'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={['Pemilik', 'Saudara/Kerabat', 'Penyewa'].map(e => ({ label: e, value: e }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Jumlah Penghuni"
                      name={'jumlah_penghuni'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Lingkungan Tertata"
                      name={'lingkungan_tertata'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Ya'} >Ya</Radio>
                        <Radio value={'Tidak'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Jenis Pemukiman"
                      name={'jenis_pemukiman_id'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={jenisPemukimanMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  label="Kode Tarif"
                  name={'kode_tarif_id'}
                  rules={[{ required: true }]}
                >
                  <Select
                    options={kodeTarifMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>
                <Form.Item
                  label="Luas Bangunan"
                  name={'luas_bangunan'}
                  rules={[{ required: true }]}
                >
                  <Input suffix="m2" />
                </Form.Item>
              </RenderIf>
              <RenderIf when={stepPosition === 1} >
                <Form.Item
                  name={'latitude'}
                  hidden
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={'longitude'}
                  hidden
                >
                  <Input />
                </Form.Item>
                <Row gutter={[20]} >
                  <Col span={12} >
                    <Form.Item label="Latitude" >
                      <Input style={{ backgroundColor: pallete.grey[200] }} readOnly value={surveyData?.data?.ab?.KOORDINAT.LATITUDE} />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item label="Longitude" >
                      <Input style={{ backgroundColor: pallete.grey[200] }} readOnly value={surveyData?.data?.ab?.KOORDINAT.LONGITUDE} />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  label="Titik Lokasi Bangunan"
                  name={'lokasi_bangunan'}
                  rules={[{ required: true }]}
                >
                  <AutoComplete
                    value={selectedAddress}
                    onSearch={setSearchAddress}
                    onSelect={handleSelectAddress}
                    options={addressResponse?.map(e => (
                      {
                        value: e.display_name,
                        label: (
                          <Space direction="vertical" size={3} >
                            <Typography.Text style={{ fontSize: 12, fontWeight: 600, margin: 0 }} >
                              {e.name}
                            </Typography.Text>
                            <Typography.Text style={{ fontSize: 12, color: pallete.grey[700], margin: 0 }} >
                              {e.display_name}
                            </Typography.Text>
                          </Space>
                        )
                      }
                    ))}
                  />
                </Form.Item>
                <Card styles={{ body: { padding: 0 } }} >
                  <MapComponent
                    position={position}
                    setPosition={setPosition}
                    reverseGeocodeMutation={reverseGeocodeMutation.mutate}
                  />
                </Card>
              </RenderIf>
              <RenderIf when={stepPosition === 2} >
                <Row gutter={[20]} >
                  <Col sm={6} xs={12} >
                    <Form.Item
                      label="Regional"
                    // name={'pa_pc'}
                    >
                      <Input
                        value={surveyData?.data.ab.REGIONAL}
                        readOnly
                        style={{ backgroundColor: pallete.grey[200] }}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={6} xs={12} >
                    <Form.Item
                      label="AB"
                    >
                      <Input
                        value={surveyData?.data.ab.NAMA_AB}
                        readOnly
                        style={{ backgroundColor: pallete.grey[200] }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="PA/PC"
                      rules={[{ required: true }]}
                      name={'pa_pc'}
                    >
                      <Input
                        value={surveyData?.data?.ab?.PAPC_CODE}
                      // readOnly 
                      // style={{ backgroundColor: pallete.grey[200] }} 
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="BlOK/EZ"
                      rules={[{ required: true }]}
                      name={'blok_ez'}
                    >
                      <Input
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="NOVAK/BLOK"
                      name={'novak_blok'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={6} >
                    <Form.Item
                      label="Nomen Terdekat"
                      name={'nomen_terdekat'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24} >
                    <Form.Item
                      label="CC"
                      name={'cc'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24} >
                    <Form.Item
                      label="Sumber air lain yang digunakan pelanggan"
                      name={'sumber_lain'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={sumberAir.map(e => ({ label: e, value: e }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Jaringan Pipa"
                      name={'jaringan_pipa'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 60 }} value={'Ada'} >Ada Jaringan</Radio>
                        <Radio value={'Tidak Ada'} >Tidak Ada Jaringan</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Jarak bangunan dengan pipa existing PAM JAYA (m)"
                      name={'jarak_bangunan_dengan_pipa'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} suffix="m" />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Ukuran Pipa Input"
                      name={'ukuran_pipa_id'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={ukuranPipaMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Diameter Pipa Dinas yang akan dipasang "
                      name={'diameter_pipa_id'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={diameterPipaMaster?.data?.items.map(e => ({ label: e.name, value: e.id }))}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24} >
                    <Form.Item
                      label="Jenis jalan/galian"
                      name={'jenis_jalan_id'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={jenisJalanMaster?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Perlu crosing jalan"
                      name={'perlu_crossing_jalan'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                        <Radio value={'N'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Lebar Jalan"
                      name={'lebar_jalan'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} suffix="m" />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Perlu crosing saluran air"
                      name={'perlu_crossing_air'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                        <Radio value={'N'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Panjang casing pipa"
                      name={'panjang_casing_pipa'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} suffix="m" />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Halaman"
                      name={'halaman'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                        <Radio value={'N'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="Sanitasi"
                      name={'sanitasi'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                        <Radio value={'N'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={6} >
                    <Form.Item
                      label="Saluran Pembuangan"
                      name={'saluran_pembuangan'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                        <Radio value={'N'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={24} >
                    <Form.Item
                      label="Golongan Konsumen"
                      name={'golongan_konsumen_id'}
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={golonganKonsumenMaster?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={12} >
                    <Form.Item
                      label="Nomen Lama"
                      name={'nomen_lama'}
                      rules={[
                        {
                          required: true,
                        },
                        {
                          pattern: /^\d{8,9}$/, // Hanya angka dengan panjang 8-9 digit
                          message: "Nomor harus terdiri dari 8 hingga 9 angka!",
                        },
                      ]}
                    >
                      <Input
                        maxLength={9}
                        type="number"
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={12} >
                    <Form.Item
                      label="Tekanan Air"
                      name={'tekanan_air'}
                      rules={[{ required: true }]}
                    >
                      <InputNumber style={{ width: '100%' }} suffix="m" />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={12} >
                    <Form.Item
                      label="Peruntukan Bangunan"
                      name={'peruntukan_bangunan'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'D'} >Domestic</Radio>
                        <Radio value={'Tidak'} >Non Domestic</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={12} >
                    <Form.Item
                      label="Perlu Bor Tembok"
                      name={'perlu_bor_tembok'}
                      rules={[{ required: true }]}
                    >
                      <Radio.Group>
                        <Radio style={{ marginRight: 120 }} value={'Y'} >Ya</Radio>
                        <Radio value={'N'} >Tidak</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </RenderIf>
              <RenderIf when={stepPosition == 3} >
                <Row gutter={[20]} >
                  <Col span={12} >
                    <Form.Item
                      label="Kamar Tidur"
                      name={'kamar_tidur'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Kamar Mandi"
                      name={'kamar_mandi'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Ruang Tamu"
                      name={'ruang_tamu'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Ruang Makan"
                      name={'ruang_makan'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Ruang Keluarga"
                      name={'ruang_keluarga'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Dapur"
                      name={'dapur'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Teras"
                      name={'teras'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Garasi"
                      name={'garasi'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Gudang/Paviliun"
                      name={'gudang'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12} >
                    <Form.Item
                      label="Jumlah Lantai"
                      name={'jumlah_lantai'}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </RenderIf>
              <RenderIf when={stepPosition == 4} >
                <Form.Item
                  label="Program Sambungan Baru"
                  name={'program_sambungan_baru_id'}
                  rules={[{ required: true }]}
                >
                  <Select
                    options={programSambunganBaru?.data?.items?.map(e => ({ label: e.name, value: e.id }))}
                  />
                </Form.Item>
                <Form.Item
                  label="Program Kategori"
                  name={'program_kategori'}
                  rules={[{ required: true }]}
                >
                  <Select
                    options={['Adhoc', 'Infill'].map(e => ({ label: e, value: e }))}
                  />
                </Form.Item>
                <Form.Item
                  label="Nama Program Kategori"
                  name={'nama_program_kategori'}
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Object ID BNBA"
                  name={'object_id_bnba'}
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Field Survey ID Field Maps BNBA"
                  name={'field_survey_id_maps_bnba'}
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Skema Pembayaran"
                  name={'skema_pembayaran'}
                  rules={[{ required: true }]}
                >
                  <Select
                    options={skemaPembayaran.map(e => ({ label: e, value: e }))}
                  />
                </Form.Item>
                <Form.Item
                  label="Informasi Tambahan"
                  name={'keterangan_lain'}
                >
                  <Input.TextArea rows={5} />
                </Form.Item>
                <Descriptions
                  column={1}
                  bordered
                  style={{ marginTop: 24 }}
                  styles={{ label: { width: 110 }, content: { width: '100%' } }}
                  size="small"
                  items={[
                    {
                      label: 'KTP',
                      children: (
                        <Flex gap={8} align="center" >
                          <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.acceptance?.registration?.ktp}</Typography.Text>
                          <Flex gap={8} vertical={!breakpoint.lg} >
                            <Button
                              icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                              size="small"
                              variant="filled"
                              color="orange"
                              onClick={() => onChangeDocument('ktp')}
                            >
                              Ganti
                            </Button>
                            <Button
                              icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                            >
                              <Link to={`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.kk}`} >
                                Unduh
                              </Link>
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.ktp}`)}
                            >
                              Lihat
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => {
                                navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.ktp}`)
                                message.success('Link berhasil disalin')
                              }}
                            >
                              Salin Link
                            </Button>
                          </Flex>

                        </Flex>
                      )
                    },
                    {
                      label: 'KK',
                      children: (
                        <Flex gap={8} align="center" >
                          <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.acceptance?.registration?.kk}</Typography.Text>
                          <Flex gap={8} vertical={!breakpoint.lg} >
                            <Button
                              icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                              size="small"
                              variant="filled"
                              color="orange"
                              onClick={() => onChangeDocument('kk')}
                            >
                              Ganti
                            </Button>
                            <Button
                              icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                            >
                              Unduh
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.kk}`)}
                            >
                              Lihat
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => {
                                navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.kk}`)
                                message.success('Link berhasil disalin')
                              }}
                            >
                              Salin Link
                            </Button>
                          </Flex>
                        </Flex>
                      )
                    },
                    {
                      label: 'PBB',
                      children: (
                        <Flex gap={8} align="center" >
                          <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.acceptance?.registration?.pbb ?? '-'}</Typography.Text>
                          <RenderIf when={surveyData?.data?.acceptance?.registration?.pbb} >
                            <Flex gap={8} vertical={!breakpoint.lg} >
                              <Button
                                icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                                size="small"
                                variant="filled"
                                color="orange"
                                onClick={() => onChangeDocument('pbb')}
                              >
                                Ganti
                              </Button>
                              <Button
                                icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                                variant="filled"
                                color="primary"
                                size="small"
                                style={{ fontSize: 12 }}
                              >
                                <Link to={surveyData?.data?.acceptance?.registration?.pbb && `${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.pbb}`} >
                                  Unduh
                                </Link>
                              </Button>
                              <Button
                                variant="filled"
                                color="primary"
                                size="small"
                                style={{ fontSize: 12 }}
                                icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                                onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.pbb}`)}
                              >
                                Lihat
                              </Button>
                              <Button
                                variant="filled"
                                color="primary"
                                size="small"
                                style={{ fontSize: 12 }}
                                icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                                onClick={() => {
                                  navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.pbb}`)
                                  message.success('Link berhasil disalin')
                                }}
                              >
                                Salin Link
                              </Button>
                            </Flex>
                          </RenderIf>
                        </Flex>
                      )
                    },
                    {
                      label: 'Bangunan',
                      children: (
                        <Flex gap={8} align="center" >
                          <Typography.Text style={{ marginRight: 'auto' }}>{surveyData?.data?.acceptance?.registration?.bangunan}</Typography.Text>
                          <Flex gap={8} vertical={!breakpoint.lg} >
                            <Button
                              icon={<Icon icon="solar:refresh-linear" style={{ marginBottom: -1 }} width="18" height="18" />}
                              size="small"
                              variant="filled"
                              color="orange"
                              onClick={() => onChangeDocument('bangunan')}
                            >
                              Ganti
                            </Button>
                            <Button
                              icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                            >
                              <Link to={`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.bangunan}`} >
                                Unduh
                              </Link>
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.bangunan}`)}
                            >
                              Lihat
                            </Button>
                            <Button
                              variant="filled"
                              color="primary"
                              size="small"
                              style={{ fontSize: 12 }}
                              icon={<Icon icon="solar:copy-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                              onClick={() => {
                                navigator.clipboard.writeText(`${API_BASE_URL}/files/registration/${surveyData?.data?.acceptance?.registration?.bangunan}`)
                                message.success('Link berhasil disalin')
                              }}
                            >
                              Salin Link
                            </Button>
                          </Flex>
                        </Flex>
                      )
                    },
                  ]}
                />
              </RenderIf>
            </Form>
            <div style={{ width: 200, borderLeft: '.5px solid ' + pallete.grey[400], paddingLeft: 20 }} >
              <Steps
                current={stepPosition}
                onChange={(val) => {
                  if (val > stepPosition) handleNext()
                }}

                items={[
                  {
                    title: <Typography.Text>Pelanggan</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Titik Koordinat</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Lokasi</Typography.Text>,
                  },
                  {
                    title: <Typography.Text>Bangunan</Typography.Text>,
                  },
                  {
                    title: <Typography.Text >Dokumen & Informasi Tambahan</Typography.Text>,
                  }
                ]}
                direction="vertical"
                style={{ height: 450 }}
              />
            </div>
          </Flex>
        </RenderIf>
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={() => setPrevieImage('')}
      >
        <embed style={{ width: '100%', height: getFileExtension(previewImage) == 'pdf' && '500px' }} src={previewImage} />
      </Modal>
      <Modal
        open={openChangeModal}
        onCancel={handleCloseChangedDocumentModal}
        title="Ganti Berkas"
        centered
        okText="Submit"
        okButtonProps={{
          disabled: !changedDocument.length,
          onClick: handleChangeDocument
        }}
        styles={{
          body: {
            paddingTop: 20,
            paddingBottom: 20,
          }
        }}
      >
        <Upload
          style={{ width: '100%', display: 'block' }}
          rootClassName="survey-upload"
          beforeUpload={async (file) => {
            await preprocessUpload(file)
            setChangedDocument([file])
            return false
          }}
          fileList={changedDocument}
          onRemove={() => {
            setChangedDocument([])
          }}
          itemRender={(_, file, filelist, action) => (
            <UploadFileRenderer
              file={file}
              action={action}
              onPreview={() => setPrevieImage(file.preview)}
            />
          )}
        >
          <Flex justify="space-between" >
            <div style={{ flex: 1 }} >
              <Typography.Text style={{ display: 'block' }} >
                <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                  *
                </Typography.Text>
                Upload Dokumen Pengganti
              </Typography.Text>
              <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                File jpeg, png, jpg, Max. file size: 2 MB
              </Typography.Text>
            </div>
            <Button
              icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
            >
              Upload
            </Button>
          </Flex>
        </Upload>
      </Modal>
    </>
  )
}